import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import SolvHealthLogo from '~/components/SolvPatternLibrary/SolvHealthLogo';

import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import { biggerThan } from '../../../core/util/styledComponents';
import PrivacyLinks from '../../AppFooter/components/PrivacyLinks';
import { isNativeApp } from '../../../core/util/device';

import AppInfo from './AppInfo';

const SmoothDialog = styled(Dialog).withConfig({ componentId: 'sc-1qy6y6n-0' })`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};

    ${biggerThan.sm`
      padding: 20px 0;
    `}
  }
`;

const Close = styled.div.withConfig({ componentId: 'sc-1qy6y6n-1' })`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.blueMonday};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.blueMonday};
  }
`;

const AboutUsCopy = styled.div.withConfig({ componentId: 'sc-1qy6y6n-2' })`
  color: ${colors.lightText};
  margin: 20px 40px 40px;
  text-align: center;
`;

const PrivacyContainer = styled.div.withConfig({ componentId: 'sc-1qy6y6n-3' })`
  a {
    text-align: center;
    display: block;
    color: ${colors.blueJayWay} !important;
    margin-bottom: 8px;
    font-size: ${fontSize.mediumSmall};
  }
`;

const Header = styled.div.withConfig({ componentId: 'sc-1qy6y6n-4' })`
  color: ${colors.squid};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
  text-align: center;
  padding-top: 64px;
`;

const CloseLink = styled.div.withConfig({ componentId: 'sc-1qy6y6n-5' })`
  margin: 40px;
  color: ${colors.blueJayWay};
  text-align: center;
  font-size: ${fontSize.default};
  text-transform: uppercase;
  cursor: pointer;
`;

type OwnProps = {
  closeModal?: (...args: any[]) => any;
  fullScreen?: boolean;
  open?: boolean;
};

const defaultProps = {
  open: false,
};
type Props = OwnProps & typeof defaultProps;

const AboutUsModal = (props: Props) => {
  const { open, fullScreen, closeModal } = props;

  return (
    <SmoothDialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      onClose={closeModal}
      open={open}
      PaperProps={{ classes: { root: 'dialog-root' } }}
      scroll="body"
      transitionDuration={{ exit: 0 }}
    >
      <Close onClick={closeModal} />

      <Header>
        <SolvHealthLogo />
      </Header>

      <AboutUsCopy>Great doctors. Available today.</AboutUsCopy>

      <PrivacyContainer>
        <PrivacyLinks />

        {isNativeApp() && <AppInfo />}
      </PrivacyContainer>

      <CloseLink onClick={closeModal}>Close</CloseLink>
    </SmoothDialog>
  );
};

export default withMobileDialog<Props>({ breakpoint: 'xs' })(AboutUsModal);
